export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15122.4afa7198.jpg";